import { useGetCustomExportRunsQuery } from './apiCalculationExport';
import { defaultCustomExportListQuery } from './customExportLib';
import { TemplateOrCalculation } from '../../../apis/api';
import { useMemo } from 'react';
import { SkipToken } from '@reduxjs/toolkit/query';
import { CustomExportRunResponse } from '@ydistri/api-sdk';

export interface CustomExportRunQueryResult {
  data: CustomExportRunResponse | undefined;
  isFetching: boolean;
  isError: boolean;
}

export const useGetLatestCustomExportRun = (
  templateOrCalculation: TemplateOrCalculation,
  skipToken?: SkipToken,
): CustomExportRunQueryResult => {
  const { data, isFetching, isError } = useGetCustomExportRunsQuery(
    skipToken ?? {
      calculationId: templateOrCalculation.id,
      query: defaultCustomExportListQuery,
    },
  );

  return useMemo(() => {
    if (data) {
      return { data: data.data.find(run => run.isLast), isFetching, isError };
    }
    return {
      data: undefined,
      isFetching,
      isError,
    };
  }, [data, isFetching, isError]);
};
